/**
 * News classification labels for LLM-assigned categories and tags.
 * Must stay in sync with news/enums.py on the backend.
 */

export const NEWS_CATEGORY_LABELS = {
    economy: 'Экономика / Бизнес',
    politics: 'Политика',
    entertainment: 'Развлечение',
    sports: 'Спорт',
    technology: 'Технологии',
    health: 'Здоровье',
    other: 'Другое',
}

export const NEWS_TAG_LABELS = {
    interview: 'Интервью',
    arrest: 'Арест',
    taxes: 'Налоги',
    investment: 'Инвестиции',
    resources: 'Ресурсы',
    divorce: 'Разводы',
    scandal: 'Скандал',
    death: 'Смерть',
    fight: 'Драка',
    epstein: 'Эпштейн',
    neural_network: 'Нейросеть',
    diplomacy: 'Дипломатия',
    cybersecurity: 'Кибербезопасность',
    security: 'Безопасность',
    other: 'Другое',
}
